<template>
  <div id="v3PassowrdRebateRoot">
    <div id="v3PassowrdRebateDivDiv">
      <div id="v3PassowrdRebateTitleDiv">
        口令输入
      </div>
      <div id="v3Close" @click="onBackClick()">x</div>
      <div id="v3ContainerDiv">
        <input :style="{ 'font-size': $store.state.inputFontSize }"
          style="width: 90%;padding-top: 8px; padding-bottom: 8px;text-align: center; border: none;border-radius: 3px;color: #575656;background-color: #EFEFEF;"
          placeholder="请输入口令" v-model="passCode" />
        <div :style="{ 'background': '-webkit-linear-gradient(left, #FA7D23,#FA7D23)', 'color':'white', 'font-size': $store.state.buttonSize }"
         @click="feedbackPassword()"
         style="margin-top:10px;padding:5px; width:40%;text-align: center;border-radius: 5px;">
          领 取
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    
  },
  data() {
    return {
      passCode: "",
    }
  },
  methods: {
    // 隐藏兑换记录页面
    onBackClick() {
      this.$parent.hidePasswordRebateDialog()
      this.passCode = ""
    },
    feedbackPassword() {
      if (this.passCode.length <= 0) {
        this.$store.commit("switchToast", { "showOrHide": true, "toastMessage": "请输入口令" })
        return
      }
      this.$parent.ensurePasswordRebate(this.passCode)
      this.passCode = ""
    }
  },
}
</script>

<style>
#v3PassowrdRebateRoot {
  /* background-color: aquamarine; */
  width: 100%;
  height: 70vh;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  background: rgba(51, 51, 51, 0.5);
  z-index: 2233;
}

#v3Close {
  z-index: 2233;
  width: 25px;
  height: 25px;
  line-height: 25px;
  background-color: #E6E6E6;
  float: right;
  position: absolute;
  top: -12px;
  right: -10px;
  text-align: center;
  border-radius: 25px;
  color: #484848;
}

#v3PassowrdRebateDivDiv {
  background-color: white;
  border-radius: 10px;
  z-index: 2000;
  width: 80%;
  height: 130px;
  position: relative;
  display: flex;
  flex-direction: column;

}

#v3PassowrdRebateTitleDiv {
  margin-top: 10px;
  background-color: white;
  color: #3E3E3E;
  font-size: small;
  font-weight: bold;
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  /* border-bottom: 1px solid #B4B4B4; */
}

#v3ContainerDiv {
  padding-top: 5px;
  padding-bottom: 5px;
  border-radius: 2px;
  margin-left: 5px;
  margin-right: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: white;
}

input::placeholder {
  color: #cecece;
}

input:focus {
  border: 1px solid #dfdfdf;
}

input {
  outline: none;
}
</style>


// WEBPACK FOOTER //
// src/views/SdkV3/rebate/V3PasswordRebateDialog.vue